var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[_c('configuracao',{key:_vm.$root.$session.versao,attrs:{"intTipoDocumentoId":280}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }